function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M0 0h50v50H0z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.637 40.377L5.084 35.73h.684l1.427 4.288H6.85l1.48-4.288h.61l1.447 4.288h-.332l1.447-4.288h.63l-1.552 4.647h-.697L8.529 36.4h.18l-1.361 3.975h-.71zm9.069-2.642h2.39v.564h-2.39v-.564zm.06 2.064h2.708v.578h-3.372V35.73h3.279v.578h-2.615v3.491zm5.236.578l2.104-4.647h.657l2.11 4.647h-.696l-1.879-4.275h.266l-1.879 4.275h-.683zm.896-1.162l.179-.531h2.615l.192.531h-2.986zm6.826 1.161v-4.645h.663v4.068h2.516v.578h-3.18zm6.586 0v-4.068h-1.593v-.578h3.843v.578h-1.593v4.069h-.657zm8.462-4.645h.663v4.645h-.663v-4.645zm-2.669 4.645h-.663v-4.645h.663v4.645zm2.728-2.07h-2.794v-.578h2.794v.578z",
  fill: "#000"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M27.323 7.965v24.447h4.988v-4.145h1.272c1.966 0 3.972-.089 5.805-.8 11.28-4.376 6.706-19.502-2.85-19.502h-9.215zm4.988 15.65V12.532h4.228c3.645 0 5.945 5.495 3.498 8.857-1.652 2.27-4.919 2.224-7.726 2.224z",
  fill: "#000"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M8.969 7.985H4.093v14.14c0 14.41 21.128 14.495 21.128 0V7.986h-5.047v14.14c0 4.064-2.425 5.297-4.084 5.666-.996.22-2.04.16-3.018-.131-1.66-.494-4.103-1.846-4.103-5.534V7.986z",
  fill: "#000"
});

function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4);
}

export default SvgLogo;